<input
  [class.field-invalid]="showError"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [id]="id"
  [matAutocomplete]="auto"
  [name]="field.key"
  [placeholder]="props.placeholder"
  [portalCyTest]="field.key"
  [readonly]="props.readonly"
  [required]="props.required || false"
  [tabIndex]="props.tabindex"
  [type]="type"
  class="field-input max-w-full"
/>

<mat-autocomplete #auto="matAutocomplete">
  <mat-option
    *ngFor="let value of filter | async"
    [value]="value"
  >
    {{ value }}
  </mat-option>
</mat-autocomplete>

<span
  *ngIf="disabled"
  class="whitespace-pre-line"
  >{{ display }}</span
>
